import { useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { Button, ModalDefault, Text } from "@ficatranquilo/contabilidade.com-ui";
import useService from "@hooks/useService";
import { escapeHtml } from "@components/ow";

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

/** Confirmação da exclusão. O modal fica aberto se o back recusar. */
export default function DeleteQuizModal({ quiz, onClose, onDeleted }) {
  const quizService = useService("quiz");
  const [loading, setLoading] = useState(false);
  const respondents = Number(quiz.totalRespondents) || 0;

  function close() {
    if (!loading) onClose();
  }

  async function confirm() {
    setLoading(true);
    try {
      await quizService.destroy(quiz.id);
      toast.success("Questionário excluído");
      setLoading(false);
      onDeleted();
    } catch (err) {
      toast.error(err?.response?.data?.msg || "Erro ao excluir o questionário");
      setLoading(false);
    }
  }

  const text = [
    "O questionário sai da lista da empresa e dos colaboradores.",
    respondents ? `As respostas de ${respondents} ${respondents === 1 ? "pessoa deixam" : "pessoas deixam"} de aparecer.` : null,
    "A exclusão não tem volta.",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <ModalDefault
      $showModal
      $setShowModal={close}
      $noClose={loading}
      $size="medium"
      $title="Excluir questionário?"
      $contentBackground="N0"
      $footer={
        <>
          <Button $text="Cancelar" $variant="outline" $action={close} $isDisabled={loading} $noWidth />
          <Button $text="Excluir questionário" $variant="danger" $action={confirm} $isLoading={loading} $noWidth />
        </>
      }
    >
      <Body>
        <Text
          $text="“%s”"
          $replaces={[escapeHtml(quiz.title || "Questionário")]}
          $variant="paragraph_small_medium"
          $color="N900"
          $colorEmphasis="N900"
        />
        <Text $text={text} $variant="paragraph_small_medium" $color="N700" />
      </Body>
    </ModalDefault>
  );
}
